import React from 'react';
import './Index.css';
import {Link} from 'react-router-dom';

const Footer = (props) => {
  return (
    <div className='container'>
      <br/>
      <Link className='clickable' to='/tnc'>
        T&C
      </Link>
      <br/>
      <Link className='clickable' to='/privacy'>
        Privacy Policy
      </Link>
      <br/>
      <Link className='clickable' to='/refunds'>
        Refunds/Cancellations
      </Link>
      <br/>
      <Link className='clickable' to='/contact'>
        Contact Us
      </Link>
    </div>
  );
}

export default Footer;